import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import { HANA_AMPLITUDE } from "../../amplitude";
import useAmplitudeLog from "../use-amplitude-log";
export var useHanaAmplitude = function useHanaAmplitude(_ref) {
  var slug = _ref.slug;
  var _useAmplitudeLog = useAmplitudeLog(),
    amplitudeEvent = _useAmplitudeLog.amplitudeEvent;
  var onRefreshTopics = function onRefreshTopics(_ref2) {
    var location = _ref2.location,
      category = _ref2.category;
    amplitudeEvent({
      event: HANA_AMPLITUDE.REFRESH_PROMPTS,
      data: {
        Source: location,
        Category: category,
        Organization: slug
      }
    });
  };
  var onSelectTopic = function onSelectTopic(category) {
    amplitudeEvent({
      event: HANA_AMPLITUDE.CATEGORY_SELECTED,
      data: {
        Category: category
      }
    });
  };
  var onSubmitPrompt = function onSubmitPrompt(source, _ref3, error) {
    var text = _ref3.text,
      category = _ref3.category;
    var data = {
      Prompt: text,
      Place: source,
      Category: category || '',
      Organization: slug
    };
    amplitudeEvent({
      event: HANA_AMPLITUDE.PROMPT_SUBMIT,
      data: !error ? data : {
        Prompt: text,
        Place: source,
        Category: category,
        Organization: slug,
        Error: error
      }
    });
  };
  var onRenderPage = function onRenderPage(page, source, _ref4) {
    var chatUrl = _ref4.chatUrl,
      chatId = _ref4.chatId;
    var data = page === 'RENDER_CHAT' ? {
      Source: source,
      'Chat URL': chatUrl,
      'Chat ID': chatId,
      Organization: slug
    } : {
      Source: source
    };
    amplitudeEvent({
      event: HANA_AMPLITUDE[page],
      data: data
    });
  };
  var onRetryPrompt = function onRetryPrompt() {
    amplitudeEvent({
      event: HANA_AMPLITUDE.ANOTHER_ANSWER
    });
  };
  var onRatingSent = function onRatingSent() {
    var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'Good';
    var _ref5 = arguments.length > 1 ? arguments[1] : undefined,
      chatUrl = _ref5.chatUrl,
      chatId = _ref5.chatId;
    var request = arguments.length > 2 ? arguments[2] : undefined;
    var data = {
      Value: value,
      'Chat URL': chatUrl,
      'Chat ID': chatId,
      Organization: slug
    };
    amplitudeEvent({
      event: HANA_AMPLITUDE.FEEDBACK_TYPE,
      data: value === 'Good' ? data : _objectSpread(_objectSpread({}, data), {}, {
        Request: request
      })
    });
  };
  var onSelectTopicHanaDashlet = function onSelectTopicHanaDashlet(category) {
    amplitudeEvent({
      event: HANA_AMPLITUDE.DASHLET_HANA,
      data: {
        Category: category,
        Organization: slug
      }
    });
  };
  var onDownloadReport = function onDownloadReport(_ref6) {
    var messageId = _ref6.messageId,
      type = _ref6.type,
      chatUrl = _ref6.chatUrl,
      chatId = _ref6.chatId,
      reportUrl = _ref6.reportUrl,
      errors = _ref6.errors;
    var data = {
      'Report Type': type,
      'Chat URL': chatUrl,
      'Chat ID': chatId,
      'Message ID': messageId,
      Organization: slug
    };
    amplitudeEvent({
      event: HANA_AMPLITUDE.REPORT_DOWNLOAD,
      data: errors ? _objectSpread(_objectSpread({}, data), {}, {
        Errors: errors
      }) : _objectSpread(_objectSpread({}, data), {}, {
        'Report URL': reportUrl
      })
    });
  };
  var onFeedbackSent = function onFeedbackSent(motive, _ref7, comment) {
    var chatUrl = _ref7.chatUrl,
      chatId = _ref7.chatId;
    amplitudeEvent({
      event: HANA_AMPLITUDE.FEEDBACK_SENT,
      data: {
        Motive: motive,
        Comment: comment,
        'Chat URL': chatUrl,
        'Chat ID': chatId,
        Organization: slug
      }
    });
  };
  var onPromptSuggestion = function onPromptSuggestion(source, _ref8) {
    var text = _ref8.text,
      prompt = _ref8.prompt;
    amplitudeEvent({
      event: HANA_AMPLITUDE.PROMPT_SUGGESTION,
      data: {
        Prompt: prompt,
        Place: source,
        Organization: slug,
        Text: text
      }
    });
  };
  // const onRefreshSuggestions = () => {
  //   amplitudeEvent({event: HANA_AMPLITUDE.});
  // };

  var onClose = function onClose(page) {
    amplitudeEvent({
      event: HANA_AMPLITUDE[page],
      data: {
        isClosing: true
      }
    });
  };
  var onError = function onError(source, request, _ref9) {
    var chatUrl = _ref9.chatUrl,
      chatId = _ref9.chatId;
    amplitudeEvent({
      event: HANA_AMPLITUDE.ERROR_OCURRED,
      data: {
        Source: source,
        Request: request,
        'Chat URL': chatUrl,
        'Chat ID': chatId,
        Organization: slug
      }
    });
  };
  var onDeleteHistorialConversation = function onDeleteHistorialConversation(conversationId) {
    amplitudeEvent({
      event: HANA_AMPLITUDE.DELETE_CONVERSATION,
      data: {
        'Conversation ID': conversationId,
        Organization: slug
      }
    });
  };
  var onClickHistorialConversation = function onClickHistorialConversation(conversationId) {
    amplitudeEvent({
      event: HANA_AMPLITUDE.PREVIUS_CONVERSATION,
      data: {
        'Conversation ID': conversationId,
        Organization: slug
      }
    });
  };
  var onPinHistorialConversation = function onPinHistorialConversation(conversationId) {
    amplitudeEvent({
      event: HANA_AMPLITUDE.PIN_CONVERSATION,
      data: {
        'Conversation ID': conversationId,
        Organization: slug
      }
    });
  };
  var onChangeNameHistorialConversation = function onChangeNameHistorialConversation(conversationId) {
    amplitudeEvent({
      event: HANA_AMPLITUDE.CHANGE_CONVERSATION,
      data: {
        'Conversation ID': conversationId,
        Organization: slug
      }
    });
  };
  return {
    onRefreshTopics: onRefreshTopics,
    onSelectTopic: onSelectTopic,
    onSubmitPrompt: onSubmitPrompt,
    onSelectTopicPrompt: onSelectTopic,
    onRenderPage: onRenderPage,
    onRetryPrompt: onRetryPrompt,
    onRatingSent: onRatingSent,
    onFeedbackSent: onFeedbackSent,
    onPromptSuggestion: onPromptSuggestion,
    // onRefreshSuggestions,
    onSelectTopicHanaDashlet: onSelectTopicHanaDashlet,
    onDeleteHistorialConversation: onDeleteHistorialConversation,
    onClickHistorialConversation: onClickHistorialConversation,
    onChangeNameHistorialConversation: onChangeNameHistorialConversation,
    onPinHistorialConversation: onPinHistorialConversation,
    onDownloadReport: onDownloadReport,
    onClose: onClose,
    onError: onError
  };
};